module.exports = __webpack_public_path__ + "img/sin.5e6ed3f1.svg";